export enum ThemeList {
  NIQLight = 'niq-light',
  NIQDark = 'niq-dark',
  System = 'system',
}

export const DEFAULT_BASE_THEME = ThemeList.NIQDark;
